import React from 'react'
import { makeStyles, Theme, Container } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
}))

type Props = {
  children: NonNullable<React.ReactNode>
}

export function AdminLayout({ children }: Props): React.ReactElement {
  const classes = useStyles()

  return <Container className={classes.container}>{children}</Container>
}
